var klaviyo = klaviyo || [];
klaviyo.init({
    account: "H3VBe9",
    platform: "shopify"
});
klaviyo.enable("backinstock", {
    trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "btn",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
    },
    modal: {
        headline: "{product_name}",
        body_content: "Register to receive a notification when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify me when available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Lato');",
        font_family: 'Avenir',
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#222",
        button_text_color: "#fff",
        button_background_color: "#391974",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const $variantSelector = document.querySelector('variant-radios') || null;
    const $klaviyoButton = document.querySelector('.klaviyo-bis-trigger');
    let $priceButtons = document.querySelectorAll('[data-button-id="AddToCartBtnPrice"]');
    if ($variantSelector) {
        const $variants = [...$variantSelector.querySelectorAll('input[type="radio"]')];
        $variants.forEach($variant => {
            $variant.addEventListener('change', function () {
                setTimeout(() => {
                    const { available, price } = $variantSelector.currentVariant;
                    $priceButtons.forEach($priceButton => $priceButton.innerText = Shopify.formatMoney(price, Shopify.money_format))

                    if (!available) {
                        $klaviyoButton.classList.remove('hidden');
                        return;
                    }

                    $klaviyoButton.classList.add('hidden');
                    return;
                }, 1000)
            })
        })
    }
})